module.exports = __webpack_public_path__ + "media/images/logo-PC-75c2b24b.png";